import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { Application } from './App';
import { BrowserRouter } from 'react-router';
import { ThemeProvider } from '@mui/material/styles';
import { appTheme } from './theme';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={appTheme}>
      <BrowserRouter>
        <Application />
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>,
);
